// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__14v16","footer":"ModalFilter_footer__1QN83"};